import AddToCartButton from '../../util/addToCartButton'

export default function Item(props) {

		//ELSE
			//let affiliateGoToPageHref="https://linksynergy.walmart.com/deeplink?id=mZBF1JmBhNo&mid=2149&u1=PM&murl=http%3A%2F%2Fwww.walmart.com%2Fip%2F" + props.current.itemId
		  let href = 'https://www.walmart.com/ip/' + props.current.itemId
			let customerRatingPercentage = ( props.current.customerRating / 5 ) * 100
			customerRatingPercentage = customerRatingPercentage.toFixed(2)
			customerRatingPercentage += '%'
			//<img src={props.current.largeImage} style={{width: '100%'}} />
			return (
				<div className='row' style={{flexDirection: 'column'}}>

						<a data-contenttype="pm" data-btnlocation="img" data-itemid={props.current.itemId}
							href={href} id='PM' target='_blank' rel='noreferrer noopener'  style={{display: 'flex', justifyContent: 'center', cursor: 'pointer'}}
						>
						<div className='col-sm-12' style={{padding: '5px', maxWidth: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
							<img src={props.current.largeImage} style={{width: '100%', maxWidth: '250px', maxHeight: '250px', pointerEvents: 'none'}} />
						</div>
						</a>

						<div className='col-sm-12 productModule-div' style={{padding: '0px 5px'}}>
						<a data-contenttype="pm" data-btnlocation="title" data-itemid={props.current.itemId} style={{ cursor: 'pointer'}}
							href={href} id='PM' target='_blank' rel='noreferrer noopener'
						>
							<span style={{fontSize: '14px'}}>
								{props.current.name}
							</span>
						</a>
						</div>

						<div className='col-sm-12'  style={{padding: '4px 5px 0px 4px'}}>
							<img src="https://firebasestorage.googleapis.com/v0/b/columbus-c4de8.appspot.com/o/util%2Fratings.png?alt=media&token=e14ea485-77d9-4144-9bc7-c317b61f271b" style={{height: '10px', background: 'linear-gradient(to right, black 0%, black ' + customerRatingPercentage + ', #e6e7e8 ' + customerRatingPercentage + ', #e6e7e8 100%)' }}   />
						</div>

						<div className='col-sm-12' style={{margin: '16px 5px 0px 5px', height: '23px'}}>
							<span style={{fontWeight: '600', fontSize: '16px'}} className=''>${props.current.salePrice}</span>
						</div>


						<div className='col-sm-12' style={{padding: '0px 5px', fontSize: '14px', color: '#000', height: '20px'}}>
									{props.current.isTwoDayShippingEligible && "2-day delivery"}
						</div>


						<div className='col-12' style={{padding: '5px', display: 'flex', justifyContent: 'center'}}>
							<AddToCartButton itemId={props.current.itemId} />
						</div>

				</div>
			);

}



// WEBPACK FOOTER //
// ./components/contentTypes/itemCarousel/item.js